import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  Form,
  Input,
  Select,
  useForm,
  useSelect,
} from "@pankod/refine-antd";

import "react-mde/lib/styles/css/react-mde-all.css";

import { IUser } from "interfaces";

export const UserCreate: React.FC<IResourceComponentsProps> = () => {

  const { formProps, saveButtonProps } = useForm<IUser>();

  const { selectProps: organizationalUnitSelectProps } = useSelect({
    resource: "organizational-units",
    hasPagination: false,
    optionLabel: "name",
    optionValue: "id",
  });

  const transformedSelectProps = {
    ...organizationalUnitSelectProps,
    options: organizationalUnitSelectProps.options?.map((option: any) => ({
      ...option,
      label: `(${option.value}) ${option.label}`,
    })),
  };

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Nombre"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Usuario"
          name="username"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input autoComplete="off"/>
        </Form.Item>
        <Form.Item
          label="Contraseña"
          name="password"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="password" autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Unidad Académica"
          name="organizational_unit_id"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Select 
            placeholder="Seleccione una unidad académica (opcional)"
            allowClear
            showSearch
            {...transformedSelectProps} 
          />
        </Form.Item>
      </Form>
    </Create>
  );
};
